class AdpSidePanelController {
  constructor() {
    this.name = 'adpSidePanel';
  }
}

export default AdpSidePanelController;



// WEBPACK FOOTER //
// ./src/app/components/adpSidePanel/adpSidePanel.controller.js